import { isRoleArn } from "../EmrStagingIntegrationForm/EmrStagingIntegrationForm.utils";
import {
  type EmrAutoTuneEntry,
  emrAutoTuneSchema,
} from "./EmrAutoTuneIntegrationForm.types";

export function emptyEmrAutoTune(): EmrAutoTuneEntry {
  return emrAutoTuneSchema.parse({});
}

export function canSaveEmrAutoTune(entry: EmrAutoTuneEntry) {
  return isRoleArn(entry.role_arn);
}
